<template>
    <div class="sketch-content flex">
        <div class="page-content">
            <SketchBreadcrumb pageName="Activități"></SketchBreadcrumb>
            <div ref="parent_div" class="padding-box" @scroll="handleScroll">
                <div class="white-box flex space-between align-center">
                    <div ref="scrollTo">
                        <h3 class="module-title">Completează cu atenție detaliile cu privire la Activițăți și subactivități</h3>
                        <p>Aceaste informații vor fi introduse in sistemul informatic MySmis.</p>
                    </div>
                    <img src="@/assets/images/M3/M3Sketch/warning-sign.png" class="warning-sign">
                </div>
                <M3Warn v-if="allData && allData.m3_project && allData.m3_project.duplicate_sections && allData.m3_project.duplicate_sections.includes('activities')" type="yellow" :text="'Această secțiune a fost duplicată din proiectul companiei ' + getCompanyName(allData.m3_project.duplicate_company_id)"></M3Warn>
                <ActivitatiSubactivitati :activitati="activitati" :checkScroll="checkScroll" :allData="allData" @gantBuilt="sendGant($event)" @formComplete="completePage('add')" @formIncomplete="completePage('remove')"></ActivitatiSubactivitati>
                <ActivitatiGantt :activitati="gantt" @formComplete="completePage('add')" @formIncomplete="completePage('remove')"></ActivitatiGantt>
                <b-icon-chevron-up class="back-to-top" @click="scrollToTop()"></b-icon-chevron-up>
            </div>
        </div>
    </div>
</template>

<script>
    import ActivitatiSubactivitati from '../components/activitati-forms/ActivitatiSubactivitati'
    import ActivitatiGantt from '../components/activitati-forms/ActivitatiGantt'
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import { BIconChevronUp } from 'bootstrap-vue'
    import M3Warn from "../components/M3Warn";

    export default {
        components: {
            ActivitatiSubactivitati,
            ActivitatiGantt,
            SketchBreadcrumb,
            BIconChevronUp,
            M3Warn
        },
        data() {
            return {
                activitati: null,
                completed: 0,
                gantt: [],
                checkScroll:false,
            }
        },
        computed: {
            allData() {
                return this.$store.getters['m3Sketch/allData']
            },
            companies() {
                return this.$store.getters['m3Sketch/companies'];
            },
        },
        watch: {
            allData: {
                handler () {
                    this.getActivities()
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
        },
        methods: {
            sendGant(event) {
                this.gantt = event
            },
            getCompanyName(id){
                let name = '';
                this.companies.forEach(company => {
                    if(Number(company.id) === Number(id))
                        name = company.name
                })

                return name;
            },
            completePage(event) {
                this.section = {
                    section: 'activitati'
                }
                this.completed = event === 'add';
                if(this.completed){
                    this.$emit('achizitiiChanged')
                    this.$store.dispatch('pages/addPage', this.section)
                } else{
                    this.$store.dispatch('pages/removePage', this.section)
                }

            },
            getActivities() {
                if(this.allData && this.allData.m3_project && this.allData.m3_project.activities){
                    this.activitati =  {
                        activitati: this.allData.m3_project.activities.activities,
                        completed: this.allData.m3_project.activities.checked,
                        achizitii: this.allData.m3_project.acquisitions
                    }
                }
                this.$store.dispatch('pageLoading/setLoading', false)
            },
            handleScroll(){
                if(this.$refs.parent_div.scrollTop > 0.05*this.$refs.parent_div.scrollHeight){
                    this.checkScroll = true;
                } else {
                    this.checkScroll = false;
                }
            },
            scrollToTop() {
                this.$refs.scrollTo.scrollIntoView({behavior: 'smooth', block: "center"});
            },
        }
    }
</script>

<style scoped>
.back-to-top{
    cursor: pointer;
    position: sticky;
    bottom: -10px;
    left: 100%;
    color: #fff;
    z-index: 99999;
    padding: 4px;
    border-radius: 4px;
    font-size: 25px;
    background: #8c6984;
}
.page-content{
  position: relative;
}
.sketch-breadcrumb + .padding-box {
    height: 100%;
}
.space-between{
    justify-content: space-between;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.module-title{
    margin: 0;
    color: #5b6276;
    font-size: 14px;
    margin-bottom: 5px;
}
.white-box{
    width: 100%;
}
.white-box p{
    color: #777e90;
    font-size: 12px;
    margin: 0;
    max-width: 960px;
}
.warning-sign{
    margin-left: 50px;
}
</style>
